import { Component, OnInit } from '@angular/core';
import { ApplicationService } from 'app/services/application.service';
import { StatusService } from 'app/services/status.service';
import { AuthWebService } from 'app/services/authweb.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CompliancereturnsService } from 'app/services/compliancereturns.service';
import { CalendarService } from './../.././services/calendar.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-carrier-compliance-list',
  templateUrl: './carrier-compliance-list.component.html',
  styleUrls: ['./carrier-compliance-list.component.css']
})
export class CarrierComplianceListComponent implements OnInit {

  pageSize: number = 10;
  count: number = 0;
  isEmpty: boolean = false;
  compliancelist: any;
  calendarList: any = [];
  carrierListFilter: any = [];
  lastSixMonths: any = [];
  selectedTab = 0;
  AllCompliances:any;
  DueCompliances:any;
  OverDueAllCompliances:any;
  constructor(private router: Router, public utility: UtilityServiceService, public complianceservice: CompliancereturnsService, public _calandarService: CalendarService) { }

  ngOnInit() {
    // this._calandarService.getFirstMonths().subscribe(data => {
    //   this.calendarList = data;
    //   const dt = new Date();
    //   const thisMothCal = this.calendarList.find(x => dt.getMonth() + 1 == new Date(x.calendar_date).getMonth() + 1 && dt.getFullYear() == new Date(x.calendar_date).getFullYear());
    //   this.selectMonth(thisMothCal.id);
    //   this.lastSixMonths = this.calendarList.slice(Math.max(this.calendarList.length - 6, 0));
      //console.log( this.lastSixMonths);
    // });
    console.log(environment.authWebApi.userData);
    this.getAllCompliances(environment.authWebApi.userData.User.ID);
  }

  getAllCompliances(id)
  {
    console.log(id);

    this.complianceservice.GetAllComplianceRecords(id).subscribe(results => {
      console.log(results);
      
      if(results != null || results != undefined)
        {
          this.compliancelist = results;

        }
    });
  }

  clickCarrier(item){
    let url: any = "carrier/compliance/return/list/" + item.carrier_id + "/" + item.calendar_id;
    this.router.navigate([url]);
  }

  onChange(): void {

  }
  onSearch(): void {

  }
  onReset(): void {

  }

  // checkThisMonth(calendar) {
  //   const dateConv = new Date(calendar.calendar_date);
  //   const dt = new Date();
  //   if (dt.getMonth() + 1 == dateConv.getMonth() + 1 && dt.getFullYear() == dateConv.getFullYear()) {
  //     return true;
  //   }
  //   return false;
  // }

  // selectMonth(item: any) {
  //   this.carrierListFilter = [];
  //   this.complianceservice.getcarrierlist(item).subscribe((data: any) => {
  //     if (data != undefined || data != null) {
  //       this.carrierlist = data;
  //       this.carrierlist.forEach(element => {
  //         if (!this.carrierListFilter.some(x => x.CarrierId == element.carrier_id))
  //           this.carrierListFilter.push({ CarrierId: element.carrier_id, CarrierName: element.name });
  //       });
  //       //console.log(this.carrierListFilter);
  //     }

  //     //console.log(data);
  //     this.carrierlist = data;
  //   })


  // }
}
